import { Component } from '@angular/core';
import { Instagram } from '@awesome-cordova-plugins/instagram/ngx';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { Observable, Observer } from 'rxjs';
import { UserProvider } from '../../../providers/user/user';
import { Router } from '@angular/router';

@Component({
    selector: 'page-success-payment',
    templateUrl: 'success-payment.html',
    styleUrls:['./success-payment.scss']
})
export class SuccessPaymentPage {
    imageUrl;
    token;

    constructor(
        private router:Router,
        private instagram: Instagram,
        private loadingCtrl: LoadingController,
        private userService: UserProvider
    ) {
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state || {};
        this.imageUrl = state["image"];
        this.token = state["token"];
        this.onPost();
        this.addNewPicture();
    }

    async addNewPicture() {
        let loader = await this.loadingCtrl.create({ message: 'loading' });
        loader.present();
        let base64Image = "";
        this.getBase64ImageFromURL(this.imageUrl).subscribe(base64data => {
            base64Image = 'data:image/jpeg;base64,' + base64data;
            this.userService.createPhotoWithToken(-1, base64Image, this.token).then(data => {
                console.log('success upload: ', data);
                loader.dismiss();
            });
        });
    }

    onShare() {
        this.onPost()
    }

    onPost() {
        let base64Image = "";
        this.getBase64ImageFromURL(this.imageUrl).subscribe(base64data => {
            console.log(base64data);
            base64Image = 'data:image/jpeg;base64,' + base64data;

            this.instagram.share(base64Image);
        });
    }

    getBase64ImageFromURL(url: string) {
        return Observable.create((observer: Observer<string>) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = url;
            if (!img.complete) {
                img.onload = () => {
                    observer.next(this.getBase64Image(img));
                    observer.complete();
                };
                img.onerror = (err) => {
                    observer.error(err);
                };
            } else {
                observer.next(this.getBase64Image(img));
                observer.complete();
            }
        });
    }

    getBase64Image(img: HTMLImageElement) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    }
}
